import { getAuthAppOrigin } from "@/lib/authOrigin";

/**
 * URL absolue vers l’app FastSell « centrale » (marketing, légal, dashboard).
 *
 * À utiliser pour les `<a href>` quand le composant peut être monté sur un hôte
 * vitrine (`*.usefastsell.com`) : avec React Router, `Link to="/legal/..."` resterait
 * sur ce sous-domaine et finirait en 404.
 */
export function marketingUrl(path: string): string {
  const origin = getAuthAppOrigin();
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${origin}${normalized}`;
}
